
// components/company/CompanyModal.js
import Modal from 'components/ui/modal';
import Button from 'components/ui/button';
import Input from 'components/ui/input';
// import Switch from 'components/ui/switch';

const CompanyModal = ({ isOpen, onClose, mode, formData, errors, onChange, onSave }) => {
  const isEditMode = mode === 'edit';
  
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="p-6">
        <h2 className="text-xl font-semibold mb-4">
          {isEditMode ? 'Edit Company' : 'Add New Company'}
        </h2>
        
        <div className="space-y-4">
          <div>
            <label htmlFor="name" className="block text-sm font-medium text-gray-700">
              Company Name *
            </label>
            <Input
              id="name"
              type="text"
              value={formData.name}
              onChange={(e) => onChange('name', e.target.value)}
              className={`mt-1 block w-full ${errors.name ? 'border-red-500' : ''}`}
            />
            {errors.name && (
              <p className="mt-1 text-sm text-red-600">{errors.name}</p>
            )}
          </div>
          
          <div>
            <label htmlFor="code" className="block text-sm font-medium text-gray-700">
              Company Code
            </label>
            <Input
              id="code"
              type="text"
              value={formData.code}
              onChange={(e) => onChange('code', e.target.value)}
              className="mt-1 block w-full"
            />
          </div>
          
          <div>
            <label htmlFor="address" className="block text-sm font-medium text-gray-700">
              Address
            </label>
            <Input
              id="address"
              type="text"
              value={formData.address}
              onChange={(e) => onChange('address', e.target.value)}
              className="mt-1 block w-full"
            />
          </div>
          
          <div>
            <label htmlFor="contact_email" className="block text-sm font-medium text-gray-700">
              Contact Email
            </label>
            <Input
              id="contact_email"
              type="email"
              value={formData.contact_email}
              onChange={(e) => onChange('contact_email', e.target.value)}
              className="mt-1 block w-full"
            />
          </div>
          
          <div>
            <label htmlFor="contact_phone" className="block text-sm font-medium text-gray-700">
              Contact Phone
            </label>
            <Input
              id="contact_phone"
              type="text"
              value={formData.contact_phone}
              onChange={(e) => onChange('contact_phone', e.target.value)}
              className="mt-1 block w-full"
            />
          </div>
          
          {/* <div className="flex items-center">
            <Switch
              id="is_active"
              checked={formData.is_active}
              onChange={(checked) => onChange('is_active', checked)}
            />
            <label htmlFor="is_active" className="ml-2 block text-sm text-gray-700">
              Active
            </label>
          </div> */}
        </div>
        
        <div className="flex justify-end space-x-3 mt-6">
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={onSave}>
            {isEditMode ? 'Save Changes' : 'Add Company'}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CompanyModal;